import { Button } from "@crew/ui/components/button";
import { FieldError } from "@crew/ui/components/field";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useNavigate } from "react-router-dom";
import { api, errorHint } from "../../app/api";
import { meKey, type Me } from "../../app/me";
import { AuthCard } from "../auth/auth-card";
import { SignedInAs } from "../auth/logout-controls";

/**
 * Slice 0's fake checkout: one button, no payment. The billing stage replaces
 * it with Stripe Checkout.
 */
export function CheckoutPage({ me }: { me: Me }) {
  const navigate = useNavigate();
  const client = useQueryClient();
  const checkout = useMutation({
    mutationFn: () => api("POST", "/api/billing/checkout"),
    onSuccess: async () => {
      await client.invalidateQueries({ queryKey: meKey });
      // Setup and Connect your AI come next (slice 1b spec §6.1).
      navigate("/setup", { replace: true });
    },
  });
  const owner = me.user.role === "owner";

  return (
    <AuthCard
      title={`Start ${me.workspace.name}`}
      description="$99 a month for your crew and a computer of its own. Test mode: nothing is charged."
      footer={<SignedInAs email={me.user.email} />}
    >
      <div className="flex flex-col gap-3">
        {owner ? (
          <Button onClick={() => checkout.mutate()} disabled={checkout.isPending}>
            {checkout.isPending ? "Starting…" : "Start (test mode)"}
          </Button>
        ) : (
          <p className="text-sm text-muted-foreground">Ask the workspace owner to start it.</p>
        )}
        {checkout.error ? <FieldError>{errorHint(checkout.error)}</FieldError> : null}
      </div>
    </AuthCard>
  );
}
